import { Check } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

const ABOUT_IMG =
  "https://customer-assets.emergentagent.com/job_intl-food-commerce/artifacts/qmcjrwri_refrescos-bandeirantes-scaffalature-drive-in.1.6.avif";

const About = () => {
  const { t } = useLang();
  const bullets = [t.about.bullet1, t.about.bullet2, t.about.bullet3, t.about.bullet4];

  return (
    <section id="about" data-testid="about-section" className="section-pad bg-[#FAFAF8]">
      <div className="container-cust grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* Image — asymmetric editorial */}
        <div className="lg:col-span-5 relative">
          <div className="relative overflow-hidden rounded-sm">
            <img
              src={ABOUT_IMG}
              alt="Premium beverage bottles"
              className="w-full h-[480px] lg:h-[600px] object-cover"
            />
          </div>
          <div className="hidden lg:block absolute -bottom-8 -right-8 bg-[#0E5A4E] text-white p-8 max-w-[280px]">
            <div className="font-serif-display text-3xl leading-tight">
              15 anni
            </div>
            <div className="text-xs uppercase tracking-widest mt-2 opacity-80">
              di esperienza nel commercio internazionale
            </div>
          </div>
        </div>

        {/* Text */}
        <div className="lg:col-span-7">
          <p className="eyebrow mb-5">
            <span className="eyebrow-line"></span>
            {t.about.eyebrow}
          </p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#1A2421] leading-tight max-w-2xl">
            {t.about.title}
          </h2>
          <div className="divider-line my-8 max-w-md" />
          <p className="text-[#4A5D58] text-base md:text-lg leading-relaxed mb-6 max-w-2xl">
            {t.about.paragraph1}
          </p>
          <p className="text-[#4A5D58] text-base md:text-lg leading-relaxed mb-10 max-w-2xl">
            {t.about.paragraph2}
          </p>

          <ul className="grid sm:grid-cols-2 gap-5">
            {bullets.map((b, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="mt-1 inline-flex w-5 h-5 items-center justify-center rounded-full bg-[#0E5A4E] text-white flex-shrink-0">
                  <Check className="w-3 h-3" />
                </span>
                <span className="text-sm text-[#1A2421]">{b}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
